import { Card } from '@jetstream/core';
import {
  MY_HOURS_JOB_AIDS_URL,
  MY_HOURS_JOB_AIDS_URL_LABEL,
  SENIORITY_LIST_JOB_AIDS_URL,
  SENIORITY_LIST_JOB_AIDS_URL_LABEL
} from './constants/urlConstants';

const QuickLinksCardComponent = () => {
  return (
    <div className="quick-links">
      <div className="section-title">Quick Links</div>
      <Card
        id="seniority-link"
        className="quick-links-card"
        iconCard={{
          iconName: 'information-circle-outline',
          text: SENIORITY_LIST_JOB_AIDS_URL_LABEL,
          size: 50,
          color: 'white'
        }}
        isButton
        onClick={() => {
          window.open(SENIORITY_LIST_JOB_AIDS_URL);
        }}
      />
      <Card
        id="myhours-link"
        className="quick-links-card"
        iconCard={{
          iconName: 'information-circle-outline',
          text: MY_HOURS_JOB_AIDS_URL_LABEL,
          size: 50,
          color: 'black'
        }}
        isButton
        onClick={() => {
          window.open(MY_HOURS_JOB_AIDS_URL);
        }}
      />
    </div>
  );
};

export default QuickLinksCardComponent;
